import {
  Button,
  color,
  Empty,
  Form,
  Grid,
  Modal,
  spacing,
  TextField,
  Typography,
  typography,
  useModal,
} from '@gyym/ui'
import React from 'react'
import styled from 'styled-components'

import { useFacilityNameSearchHistories } from './useSearchHistories'

export const History = styled.li`
  width: 100%;

  &:last-child {
    border-bottom: 1px solid ${color('gray.05')};
  }

  & > button,
  & > a {
    ${typography('caption1')};
    transition: none;
    color: ${color('gray.01')};
    width: 100%;
    background: none;
    display: flex;
    gap: ${spacing(2)};
    cursor: pointer;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
    padding: ${spacing(4, 0)};
    border: none;
    border-top: 1px solid ${color('gray.05')};
    border-radius: 0;
  }
`

const FacilityNameSearchForm = ({
  onSubmit,
  onHistoryNavigate,
  onClose,
}: {
  onSubmit: (args: { facilityName: string }) => void
  onHistoryNavigate: (args: { facilityName: string }) => void
  onClose?: () => void
}) => {
  const [facilityName, setFacilityName] = React.useState('')
  const histories = useFacilityNameSearchHistories()

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit({ facilityName })
        onClose?.()
      }}
    >
      <Modal.Body>
        <TextField
          label="施設名"
          placeholder="施設名を入力"
          value={facilityName}
          onChange={(e) => setFacilityName(e.target.value)}
        />

        <Typography variant="subhead1" as="h2" mt={6}>
          検索履歴
        </Typography>

        {histories.length === 0 && <Empty mt={4}>検索履歴がありません</Empty>}

        {histories.length > 0 && (
          <Grid as="ul" mt={4} columns={1}>
            {histories.map((facilityName, i) => (
              <History key={i}>
                <Button
                  onClick={() => {
                    onHistoryNavigate({ facilityName })
                    onClose?.()
                  }}
                >
                  {facilityName}
                </Button>
              </History>
            ))}
          </Grid>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          disabled={!facilityName}
        >
          この内容で検索
        </Button>
      </Modal.Footer>
    </Form>
  )
}

export const useSearchFacilityNameModal = () => {
  const { openModal } = useModal()

  return React.useCallback(
    ({
      title = '施設名から探す',
      onSubmit,
      onClose,
      onHistoryNavigate,
    }: {
      title?: string
      onSubmit: (values: { facilityName: string }) => void
      onClose?: () => void
      onHistoryNavigate: (values: { facilityName: string }) => void
    }) => {
      openModal(Modal, {
        title,
        baseWidth: 500,
        expandOnSmallDevices: true,
        onClose,
        children: ({ onClose }) => {
          return (
            <FacilityNameSearchForm
              onSubmit={onSubmit}
              onHistoryNavigate={onHistoryNavigate}
              onClose={onClose}
            />
          )
        },
      })
    },
    [openModal],
  )
}
